
    export default {
    
        "./App": async () => {
          const importModule = await import("./src/export-app.tsx")
          const exportModule = {}
          Object.assign(exportModule, importModule)
          Object.defineProperty(exportModule, "__esModule", {
            value: true,
            enumerable: false
          })
          return exportModule
        }
      
  }
  